export const superChat = {
  // 合成入力（LiveSuperChatComposer）ヘッダー
  composerTitle: "スパチャで送る",
  composerHint: "— 金額を選ぶとコメントが目立ちます",
  // 金額チップ先頭の「通常コメントで送る」選択肢
  tierNone: "なし",
  sendNormal: "送信",
  // 「なし」選択時（通常コメント）の注記
  costNoteNormal: "ポイント消費なしで送信します",
  // 金額チップ選択時の注記（消費pt・保有ptを併記）
  costNote: (args: { point: string | number; balance: string | number }) =>
    `${args.point}pt を消費します（保有 ${args.balance}pt）`,
  // BE設定値（max_message_length）のコードポイント上限案内。通常コメントの
  // LIVE_COMMENT_MAX_LENGTH（15）とは別管轄のため、値はFEに固定で持たず呼び出し側から渡す
  tooLong: (args: { max: string | number }) =>
    `${args.max}文字以内で入力してください`,
  // 金額選択中の残り文字数表示
  remainingChars: (args: { count: string | number }) => `残り${args.count}文字`,
  // エラー文言
  liveNotFound: "配信が終了した可能性があります",
  notAvailable: "この配信ではスパチャを送信できません",
  sendError: "スパチャを送信できませんでした",
  // ピンカードの a11y ラベル
  pinnedAriaLabel: (args: { name: string | number; point: string | number }) =>
    `${args.name}さんのスパチャ（${args.point}pt）`,
  // 無期限（is_permanent）ピンの残り時間バー代わりのバッジ
  permanentBadge: "配信中ずっと表示",
  // コインチップ行で同額を畳んだときの件数（1件のときは出さない）
  coinChipCount: (args: { count: string | number }) => `×${args.count}`,
} as const;
